<div>
  <ncp-button
    #btn
    [options]="btnOptions()"
  />
  <ncp-modal
    #mod
    [options]="modOptions()"
  />
</div>
